import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { UserType } from "../../interfaces/general";

interface AuthSliceStateInterface {
    user: UserType | null;
    authStatus: "VALID" | "INVALID" | "PENDING";
    livePermission: boolean;
}

const authSliceState: AuthSliceStateInterface = {
    user: null,
    authStatus: "PENDING",
    livePermission: false
};

export const authSlice = createSlice({
    name: "auth",
    initialState: authSliceState,
    reducers: {
        setUser: (state, action: PayloadAction<UserType | null>) => {
            state.user = action.payload;
        },
        setAuthStatus: (state, action: PayloadAction<"VALID" | "INVALID" | "PENDING">) => {
            state.authStatus = action.payload;
        },
        setLivePermission: (state, action: PayloadAction<boolean>) => {
            state.livePermission = action.payload;
        }
    }
});

export const { setUser, setAuthStatus, setLivePermission } = authSlice.actions;
export const selectAuth = (state: RootState) => state.auth;
export default authSlice.reducer;
